module.exports = __webpack_public_path__ + "assets/img/f7ad-pl.svg";